import { getDefinition } from "./catalog";
import { DEFAULT_SOC } from "./simulate/battery-runtime";
import { getSimulateStateSpec } from "./simulate/states";
import { initialSimulateState, type SimulateState } from "./simulate-store-slice";
import type { System } from "./types";

/** A fresh, transient scenario for any published example. Engines retain their
 * catalog default; solar starts cloudy, compatible chargers and loads are on. */
export function exampleSimulateState(system: System): SimulateState {
  const state = initialSimulateState();
  for (const node of system.nodes) {
    if (node.kind !== "component") continue;
    const definition = getDefinition(node.definitionId, node.customDefinition);
    if (!definition) continue;
    if (definition.category === "battery") state.batterySoc[node.id] = DEFAULT_SOC;
    if (definition.category === "load") state.loadStates[node.id] = { active: true };
    const option = definition.category === "solar" ? "cloudy" : definition.category === "charger" ? "on" : null;
    if (option && getSimulateStateSpec(definition)?.options.some((candidate) => candidate.id === option)) {
      state.componentStates[node.id] = option;
    }
  }
  return state;
}
